import { render, staticRenderFns } from "./AppStoreGridRow.vue?vue&type=template&id=498456c4&scoped=true&"
import script from "./AppStoreGridRow.vue?vue&type=script&lang=js&"
export * from "./AppStoreGridRow.vue?vue&type=script&lang=js&"
import style0 from "./AppStoreGridRow.scss?vue&type=style&index=0&id=498456c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498456c4",
  null
  
)

export default component.exports